import {
  BasketColumn,
  BasketColumnKeys,
} from 'graphql-api/baskets-api-interfaces';

const fixColumn = (
  key: BasketColumnKeys,
  columnValue: BasketColumn | undefined,
): BasketColumn =>
  columnValue || {
    key,
  };

export const hideUnusedColumns = (
  headerColumns: BasketColumn[],
  productColumns: BasketColumn[],
) =>
  headerColumns
    .map((column) => column.key)
    .map((key) => {
      const result = productColumns.find((column) => column.key === key);
      return fixColumn(key, result);
    });

export const removeUnusedColumns = (
  headerColumns: BasketColumn[],
  productColumns: BasketColumn[],
): BasketColumn[] =>
  productColumns
    .filter(({ key }) => {
      return headerColumns.find((headerColumn) => key === headerColumn.key);
    })
    .sort(
      (a, b) =>
        headerColumns.findIndex((h) => h.key === a.key) -
        headerColumns.findIndex((h) => h.key === b.key),
    );
